import { Http, Url } from '@intelipost-js/secure-providers';

export default {
  getAddress({ commit }, zipCode) {
    const zipCodeFormatted = zipCode.replace(/\D/g, '');
    commit('setLoading', true);

    return Http.get(Url.toQueryString('api/v1/cep_location/address_complete', null, [zipCodeFormatted]))
      .then((res) => {
        commit('setLoading', false);

        const {
          street,
          neighborhood,
          city,
          state,
          state_short,
          bairro,
        } = res.data.content;

        commit('setAddress', {
          address: street,
          quarter: neighborhood || bairro,
          city,
          state,
          state_short,
        });
      })
      .catch(() => {
        commit('setLoading', false);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/address/actions.js